
import API from '@/api/index';

export default {
  // The install method will be called with the Vue constructor as
  // the first argument, along with possible options
  async install(Vue, options) {
		
		if(LANGUAGEAPP=="es_MX"){
			LANGUAGEAPP = "es"
		}

		var language = {}

		if(LANGUAGEAPP!="en"){
			try {
				const apiResponse = await API.phpAppEndpoints.getTranslate({ body:{language:LANGUAGEAPP+".json"} });
				language = apiResponse.data
				if(LANGUAGEAPP == "es"){
					language["Private"] = "Privado"
					language["Who is this for"] = "Para quien es"
					language["What is needed for this course"] = "Lo que necesitas"
					language["Live"] = "En vivo"
					language["Free"] = "Gratis"
					language["Free!"] = "Gratis"
					language["FREE"] = "Gratis"
					language["FREE!"] = "Gratis"
					language["Enroll"] = "Inscríbete"
					language["Email Address or Username"] = "Correo electrónico ó usuario"	
					language["Log In, already have an account"] = "Iniciar sesión, ya tengo una cuenta"
					language["Home"] = "Inicio"
					language["onsite"] = "presencial"
					language["blended"] = "combinado"
					language["online"] = "en línea"
					language["Jan"] = "Ene"
					language["Apr"] = "Abr"
					language["Aug"] = "Ago"
					language["Dec"] = "Dic"
					language["About"] = "Acerca del curso"
					language["Mode"] = "Modo"
					language["Complete your Registration"] = "Completar Inscripción"
					language["Complete Registration"] = "Completar Inscripción"
					language["Disabled"] = "Deshabilitado"
					language["Disabled. Show event as Full, when there are no more seats available."] = "Deshabilitado. Mostrar evento como Completo, cuando no haya más asientos disponibles."

					if(window.location.href.includes("saludfamiliar")){
						language["Categories"] = "CIENCIA";
						language["Hosts"] = "INSTRUCTOR";
						language["CATEGORIES"] = "CIENCIA";
						language["HOSTS"] = "INSTRUCTOR";
					}

					if(window.location.href.includes("toolkit-aprendefacil")){	
						language["Hosts"] = "EMPRESAS";
						language["HOSTS"] = "EMPRESAS";
						language["Competencies"] = "PERSONAS";
						language["COMPETENCIES"] = "PERSONAS";
					}
				}
			} catch (error) {
				console.log('errorz', error);
			}

		}else if(LANGUAGEAPP=="en"){
			
			if(window.location.href.includes("revyzed")){
				language["Enroll"] = "Tickets";
				language["ENROLL"] = "Tickets";
			}
			
			if(window.location.href.includes("carleton")){
				language["Categories"] = "TOPICS";
				language["Hosts"] = "PRESENTERS";
				language["Compotencies"] = "SESSION";
				language["CATEGORIES"] = "TOPICS";
				language["HOSTS"] = "PRESENTERS";
				language["COMPETENCIES"] = "SESSION";
			}
		}

		const corporationLabels = await API.domain.getCorporationLabels(LANGUAGEAPP);

		const labels = JSON.parse(corporationLabels.data.labels.label_body||'{}'),
			  labelKeys = Object.keys(labels);
		for(let l = 0; l < labelKeys.length; l++) {
			if(labels[labelKeys[l]]) {
				if(['Enroll', 'Categories', 'Hosts', 'Competencies', 'Waitlist'].indexOf(labelKeys[l]) !== -1) {
					language[labelKeys[l]] = labels[labelKeys[l]];
					language[labelKeys[l].toUpperCase()] = labels[labelKeys[l]].toUpperCase();
				} else {
					language[labelKeys[l]] = labels[labelKeys[l]];
				}
			}
		}
	
	Vue.locales({
	    spanish: language
	})
	  
  }
}